import gql from "graphql-tag";

export const mutation_setPreferredLanguage = gql`
  mutation ($language: String) {
    SetPreferredUILanguage(input: { preferredUILanguage: $language }) {
      success
    }
  }
`;
